import React from "react";
import './steps.css'

function Steps({stepContent}) {
    return(
        <div className="steps-container">
          {stepContent.split('\n').map((line, index) => (
            <p key={index} className="step-line">{line}</p>
          ))}
        </div>

    );
}

export default Steps